<template>
  <div style="text-align: left;">
    <h4 style="padding: 0 20px 0 20px;">
     To be updated.
    </h4>
    <full-calendar :events="fcEvents" locale="en" />
  </div>
</template>
<script>
  const demoEvents = [
    {
      title: 'to do list',
      start: '2017-11-9',
      end: '2017-11-20'
    },
    {
      title: 'Out of Office',
      start: '2017-5-18',
      end: '2017-5-18'
    }
  ];
  export default {
    data() {
      return {
        fcEvents: demoEvents
      };
    },
    methods: {}
  };
</script>

<style scoped>
</style>


// WEBPACK FOOTER //
// src/components/content/Resources.vue